import { render, staticRenderFns } from "./InformationBanner.vue?vue&type=template&id=23f42b67&scoped=true&"
import script from "./InformationBanner.vue?vue&type=script&lang=ts&"
export * from "./InformationBanner.vue?vue&type=script&lang=ts&"
import style0 from "./InformationBanner.vue?vue&type=style&index=0&id=23f42b67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f42b67",
  null
  
)

export default component.exports